import { useContext } from "react";
import useContentPermissions from "@src/components/libraryItemDetailPages/hooks/useContentPermissions";
import { ContentPermissionsFragment } from "@src/components/libraryItemDetailPages/hooks/useContentPermissions.generated";
import { SkillBuilderContext } from "@builder/skill/contexts/SkillBuilderContext";

const useSkillBuilderContentPermissions = ():
  | ContentPermissionsFragment
  | undefined => {
  const skillBuilderContext = useContext(SkillBuilderContext);
  return useContentPermissions({
    skillId: skillBuilderContext?.skillVersion?.skill.id,
  });
};

export default useSkillBuilderContentPermissions;
